export enum STEPS {
  validationCode = 'VALIDATION_CODE',
  initial = 'INITIAL',
}
